import { useTranslation } from '../../../lib/i18n';
import { FolderChooserDialog } from './FolderChooserDialog';

// "Where should these go?" — asked only when the files were chosen somewhere that has no folder of its own,
// which is the TOP of the cross-workspace browser: its rows are Spaces, and a Space is not a place bytes can
// land in.
//
// The first cut of upload simply HID the action there. That was wrong twice over: a menu item that vanishes
// with no explanation reads as broken (reported), and the question it was avoiding — which Space? — is one
// the user can answer in a single click. Asking is cheaper than hiding.
//
// The dialog itself is `FolderChooserDialog`, shared with the editor's Location row: one question, one
// picker. Only the words differ, and they are this surface's to supply.
export function UploadDestinationDialog({
  /** How many files are waiting, so the dialog can say what it is about to do. */
  count,
  onCancel,
  onConfirm,
}: {
  count: number;
  onCancel: () => void;
  onConfirm: (folder: string) => void;
}) {
  const { t } = useTranslation();
  return (
    <FolderChooserDialog
      title={t('files.upload.destinationTitle')}
      description={t('files.upload.destinationDescription', { count })}
      confirmLabel={t('files.upload.destinationConfirm')}
      onClose={onCancel}
      onChoose={onConfirm}
    />
  );
}
